import React, { useEffect, useState } from 'react';
import httpCommon from '../../../http-common';
import './FlipCard.css';

import Paper from '@mui/material/Paper';

const FlipCard = ({ category }) => {
  const [overall, setOverall] = useState("");
  const [table, setTable] = useState({});
  const [isFlipped, setIsFlipped] = useState(false);

  const fetchData = async () => {
    try {
      const response = await httpCommon.get(`/v1/qc/get_overall_${category}`);
      const result = response.data;
      const { "SLA Overall": slaOverall, "SLA Table": slaTable } = result;
      setOverall(slaOverall);
      setTable(slaTable);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFlip = () => {
    setIsFlipped(!isFlipped);
  };

  return (
    <Paper elevation={3} className={`flip-card ${isFlipped ? 'is-flipped' : ''}`} onClick={handleFlip}>
      <div className="flip-card-inner">
        <div className="flip-card-front">
          <div className="card-title">{category} Overall</div>
          <div className="card-content">
            <div className="text-4xl font-bold text-gray-900">
              {overall}
            </div>
          </div>
        </div>
        <div className="flip-card-back">
          <div className="card-title">{category} Table</div>
          <div className="w-[75%] rounded-lg overflow-hidden mb-2">
            <table className="w-full text-sm text-left text-gray-500">
              <thead className='text-xs text-gray-700 uppercase bg-gray-50'>
                <tr>
                  {/* {
                    Object.keys(table).map((key, index) => <th scope='col' className='px-6 py-3' key={`${key}-${index}`}>{key}</th>)
                  } */}
                  <th scope='col' className='px-6 py-3'>Category</th>
                  <th scope='col' className='px-6 py-3'>Value</th>
                </tr>
              </thead>
              <tbody>
                {
                  table && Object?.entries(table)?.map(([key, value], index) =>
                    <tr className='bg-white border-b' key={`${key}-${value}-${index}`}>
                      <th scope='row' className='px-6 py-3'>{key}</th>
                      <td className="px-6 py-4">{value}</td>
                    </tr>
                  )
                }
              </tbody>
            </table>
          </div>
          {/* <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ textAlign: "center" }} >Category</TableCell>
                  <TableCell sx={{ textAlign: "center" }} >Value</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.entries(table).map(([key, value]) => (
                  <TableRow key={key}>
                    <TableCell sx={{
                      textAlign: "center"
                    }}>{key}</TableCell>
                    <TableCell sx={{ textAlign: "center" }} >{value}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer> */}
        </div>
      </div>
    </Paper>
  );
};

export default FlipCard;
